import React from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase.config';

const Dashboard = () => {
  const navigate = useNavigate();
  const name = auth.currentUser ? auth.currentUser.displayName : 'User';

  const handleLogout = async () => {
    await auth.signOut();
    localStorage.removeItem('token');
    navigate('/signin');
  };

  return (
    <div>
      <h2>Welcome, {name}</h2>
      <button onClick={handleLogout}>Logout</button>
    </div>
  );
};

export default Dashboard;
